import React, { useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'

import Btn from '../ui/Btn'
import { hasListDraft } from './listDraft'
import UserDetails from './UserDetails'
import UserStats from './UserStats'
import UserActivities from './UserActivities'
import UserPosts from './UserPosts'
import './user.css'

/*
 * THE PLAYER PROFILE — a scouting report, read top to bottom.
 *
 * This is the screen where a manager decides whether to contact a player, so
 * the order is the order of that decision:
 *
 *   1. UserDetails    who they are, the physical profile, and the two actions
 *                     that follow from it (open a chat, keep them on the list)
 *   2. UserStats      the five skill ratings — the assessment itself
 *   3. UserActivities the challenges they finished, with the video evidence
 *   4. UserPosts      their media library, full width, because it is browsing
 *
 * Each child owns its own request and its own loading / empty / failed state,
 * so a dead endpoint costs one panel instead of the page.
 */

export default function User() {
  const { uuid } = useParams()
  const navigate = useNavigate()
  // UserDetails is the only child that fetches the profile; it reports the name
  // up so the video modals in the sibling panels can say whose clip is playing.
  const [playerName, setPlayerName] = useState('')

  /* Read once, on mount. Whether a search is waiting cannot change while this
     page is open, and re-checking on every render would be noise. */
  const [cameFromList] = useState(hasListDraft)

  return (
    <div className="usr-canvas">

      {/* Opening a player used to be a one-way trip: the only way back was the
          browser's Back button, which returned an empty form. The search is
          restored either way now, but a visible way back still beats making
          someone reach for browser chrome. */}
      {cameFromList && (
        <div className="usr-back">
          <Btn onClick={() => navigate('/list')}>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M15 18l-6-6 6-6" />
            </svg>
            <span>Back to your list</span>
          </Btn>
        </div>
      )}

      <div className="grid usr-split">
        <UserDetails uuid={uuid} onName={setPlayerName} />

        <div className="usr-column">
          <UserStats uuid={uuid} />
          <UserActivities uuid={uuid} name={playerName} />
        </div>
      </div>

      <UserPosts uuid={uuid} name={playerName} />

    </div>
  )
}
